import React from "react";
import { FaCheck, FaTimes } from "react-icons/fa";

const PermissionButton = ({ active, onClick, readOnly }) => {
    return (
        <div
            className={`perm-btn ${active ? "active" : "inactive"} ${readOnly ? "readonly" : ""}`}
            onClick={readOnly ? undefined : onClick}
        >
            {active ? <FaCheck size={12} /> : <FaTimes size={12} />}
        </div>
    );
};

export default PermissionButton;